export function getCurrentScrollTop ({ document, window }) {
  if (document.documentElement?.classList.contains('over-hidden')) {
    return document.body?.scrollTop || 0
  }
  return window.scrollY || window.pageYOffset || 0
}

export function createPopupScrollLock ({
  document,
  window,
  requestFrame = cb => window.requestAnimationFrame ? window.requestAnimationFrame(cb) : setTimeout(cb, 0),
  setDelay = cb => setTimeout(cb, 80),
  clearDelay = id => clearTimeout(id),
  maxUnlockRetries = 6
}) {
  const state = {
    isPopupOpen: false,
    scrollTop: 0,
    transitionId: 0,
    unlockDelayId: null
  }

  function getHtml () {
    return document.documentElement || document.getElementsByTagName('html')[0]
  }

  function isBodyLocked (classValue) {
    return String(classValue || '').split(' ').includes('el-popup-parent--hidden')
  }

  function hasVisiblePopup () {
    return Array.from(document.querySelectorAll?.('.el-dialog__wrapper, .el-message-box__wrapper') || [])
      .some((element) => {
        if (window.getComputedStyle) {
          const style = window.getComputedStyle(element)
          return style.display !== 'none' && style.visibility !== 'hidden'
        }
        return element.offsetParent !== null
      })
  }

  function clearUnlockDelay () {
    if (state.unlockDelayId !== null) {
      clearDelay(state.unlockDelayId)
      state.unlockDelayId = null
    }
  }

  function lock () {
    clearUnlockDelay()
    if (!state.isPopupOpen) {
      state.scrollTop = getCurrentScrollTop({ document, window })
    }
    state.transitionId += 1
    state.isPopupOpen = true
    getHtml()?.classList.add('over-hidden')
    document.body?.scrollTo?.(0, state.scrollTop)
  }

  function unlock () {
    const unlockId = state.transitionId
    const tryUnlock = (retryCount = 0) => {
      requestFrame(() => {
        requestFrame(() => {
          state.unlockDelayId = setDelay(() => {
            state.unlockDelayId = null
            if (unlockId !== state.transitionId || document.body?.classList.contains('el-popup-parent--hidden')) {
              return
            }
            if (hasVisiblePopup()) {
              if (retryCount < maxUnlockRetries) {
                tryUnlock(retryCount + 1)
              }
              return
            }
            state.isPopupOpen = false
            getHtml()?.classList.remove('over-hidden')
            window.scrollTo(0, state.scrollTop)
          })
        })
      })
    }
    tryUnlock()
  }

  return {
    sync (classValue) {
      if (isBodyLocked(classValue)) {
        lock()
      } else if (state.isPopupOpen) {
        unlock()
      }
    },
    reset () {
      clearUnlockDelay()
      state.transitionId += 1
      state.isPopupOpen = false
      getHtml()?.classList.remove('over-hidden')
    },
    getState () {
      return { ...state }
    }
  }
}

export default createPopupScrollLock
